// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"fcf3d47d","433":"52cdfca7","511":"0d094525","907":"3f30ee1c","925":"92b9ac83"}[chunkId] + ".chunk.js";
};